export enum EPlanFeatureType {
  POLYGON = 'Polygon',
  POINT = 'POINT',
}
